import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PriceListsTableSliceModel,
  PriceListTableItem,
} from '../../models/price-lists-table-slice.model'

const initialState: PriceListsTableSliceModel = {
  loading: false,
  loaded: false,
  priceLists: [],
  pageNumber: 1,
  totalCount: 0,
  removeModal: {
    loading: false,
    priceList: null,
  },
}

const priceListsTableSlice = createSlice({
  name: 'priceListsTable',
  initialState,
  reducers: {
    setPriceLists(state, action: PayloadAction<PriceListTableItem[]>) {
      state.priceLists = action.payload
    },
    setPageNumber(state, action: PayloadAction<number>) {
      state.pageNumber = action.payload
    },
    setTotalCount(state, action: PayloadAction<number>) {
      state.totalCount = action.payload
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setLoaded(state, action: PayloadAction<boolean>) {
      state.loaded = action.payload
    },
    resetPriceLists(state) {
      state.loaded = false
      state.loading = false
      state.pageNumber = 1
      state.totalCount = 0
      state.priceLists = []
    },
    setModalLoading(state, action: PayloadAction<boolean>) {
      state.removeModal.loading = action.payload
    },
    setModalPriceList(state, action: PayloadAction<PriceListTableItem | null>) {
      state.removeModal.priceList = action.payload
    },
  },
})

export const priceListsTableActions = priceListsTableSlice.actions

export default priceListsTableSlice
